var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-widget"},[(_vm.frameUrl)?_c('iframe',{style:(_vm.frameHeight ? ("height: " + _vm.frameHeight + "px") : ''),attrs:{"src":_vm.frameUrl,"id":_vm.frameId,"title":"Iframe Widget"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }